import script from "./module.vue?vue&type=script&setup=true&lang=ts"
export * from "./module.vue?vue&type=script&setup=true&lang=ts"

import "./module.vue?vue&type=style&index=0&id=14d450aa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14d450aa"]])

export default __exports__